import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh'
  },
  tabs: {
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '2rem'
  },
  tabIndicator: {
    backgroundColor: '#4c4cff'
  },
  tab: {
    fontWeight: 400
  },
  tabActive: {
    fontWeight: 600
  },
  content: {
    boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '2rem'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '1.5rem'
  }
});

export default useStyles;
